import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './plugins/element.js'
import VueLazyload from 'vue-lazyload' //引入这个懒加载插件

Vue.use(VueLazyload, {
	preLoad: 1,
	error: require('./assets/img/error.png'),
	loading: require('./assets/img/loading.gif'),
	attempt: 2,
})

Vue.config.productionTip = false

new Vue({
	store,
	router,
	render: h => h(App)
}).$mount('#app')